import {Link, useLoaderData, useRouteLoaderData} from '@remix-run/react'
import React, {Fragment} from 'react'
import clsx from 'clsx'
import {slugToText} from '@roundforest/text-transforms-commons'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import {ChevronRight} from '~/icons/categories-search-page/chevron-right'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import TopRatedDiscountedCard from './top-rated-discounted-card'

const TopDiscounted = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {homepageData} = newHomePageData || {}
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'top-discounted',
    widget_place: 'top',
  })

  const translations = getTranslation(language)
  const displayItems =
    homepageData?.topDiscountsOnTopRatedCategoris && homepageData?.topDiscountsOnTopRatedCategoris?.length > 1

  return displayItems ? (
    <div className={clsx('mx-auto', stylesBydomain.UTILS_MAIN_CONTAINER)} ref={widgetRef}>
      <h3 className="text-center text-xl font-semibold capitalize">{translations.Home.TopDiscounted.title}</h3>
      <div className="no-scrollbar mt-4 flex flex-row gap-5 overflow-x-scroll p-2">
        {homepageData?.topDiscountsOnTopRatedCategoris?.map((category, i) => (
          <Fragment key={`${category.slug}-${i}`}>
            <div
              className={clsx(
                'flex min-h-[480px] w-[258px] min-w-[258px] flex-col rounded-xl px-4 py-4 font-normal leading-5',
                stylesBydomain.HOMEPAGE_TOP_DISCOUNTED_BG,
                'homepage_topdiscounted_bg',
              )}
            >
              <Link
                to={`/${category.slug}`}
                prefetch="intent"
                aria-label={`view ${category.slug}`}
                className="mb-4 flex flex-row items-center justify-between gap-2 text-[18px] font-medium capitalize text-white"
              >
                {translations.Home.TopDiscounted.shopBestDeals}
                <br />
                {slugToText(category.slug)}
                <ChevronRight className="size-6" fill="#fff" />
              </Link>
              <div className="mt-auto grid grid-cols-2 flex-row gap-x-3 gap-y-5">
                {category?.products?.map((product, j) => {
                  return (
                    <Fragment key={`${product.image}-${j}`}>
                      <TopRatedDiscountedCard
                        productInfo={product}
                        index={j}
                        dealsLength={category?.products?.length}
                      />
                    </Fragment>
                  )
                })}
              </div>
              <Link
                prefetch="intent"
                aria-label={`view ${category.slug}`}
                to={`/${category.slug}`}
                className={clsx(
                  'mt-4 flex flex-row items-center justify-center gap-2 rounded-full bg-white py-1.5 text-[13px] font-semibold uppercase text-[#18297C]',
                  stylesBydomain.HOMEPAGE_BUTTON_SECONDARY,
                )}
              >
                {translations.Home.viewAll}{' '}
                <ChevronRight
                  className={clsx(
                    'size-[15px]',
                    stylesBydomain.HOMEPAGE_BUTTON_ARROW_ICON_FILL,
                    stylesBydomain.HOMEPAGE_BUTTON_ARROW_ICON_STROKE,
                  )}
                />
              </Link>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  ) : null
}

export default TopDiscounted
